import { Component, OnInit ,ElementRef ,ViewChild } from '@angular/core';
import { HeaderService } from '../header.service';
import { ErrorStateMatcher } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { BOOK_NAME_MAX } from '../../../consts/appConsts';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return control && control.invalid && isSubmitted;
    }
}

@Component({
    selector: 'lupa-edit-name',
    templateUrl: './edit-name.component.html',
    styleUrls: ['./edit-name.component.scss'],
})
export class EditNameComponent implements OnInit {
    showNameEditor: boolean;
    nameFormControl = new FormControl('', [
        Validators.required,
        Validators.maxLength(BOOK_NAME_MAX),
        Validators.minLength(2),
    ]);
    matcher = new MyErrorStateMatcher();
    submitted: boolean;
    maxLength = BOOK_NAME_MAX;
    minLength = 2;
    inputFocus = false;
    currentName: string;
    constructor(private headerService: HeaderService ) {}

    @ViewChild('bookName', { read: ElementRef })
    bookName: ElementRef;

    ngOnInit() {
        // open name editor
        this.headerService.$openNameEditor.subscribe(toOpen => {
            if (toOpen) {
                this.showNameEditor = true;
            }
        });

        this.headerService.bookName.subscribe(name => {
            this.currentName = name;
            this.nameFormControl.setValue(name);
        });
    }

    // removeEmojis(){
    //     if(this.bookName.nativeElement){
    //         //[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufc3f]|[\ufe70-\ufefc]
    //         this.bookName.nativeElement.value = this.bookName.nativeElement.value.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
    //         this.nameFormControl.setValue(this.bookName.nativeElement.value);
    //     }      
    // }
    removeEmojis(){
        
        if(this.bookName.nativeElement){
            this.bookName.nativeElement.value = this.bookName.nativeElement.value.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '');
           
            this.nameFormControl.setValue(this.bookName.nativeElement.value);

        }
    }
    onSubmit(form) {        
        if (!this.submitted)
        {
            this.submitted = true;
            
            if (!form.valid || !form.value) {
                this.submitted = false;
                return;
            }
            if (form.value === this.currentName) {
                this.showNameEditor = false;
                this.submitted = false;
                return;
            }
            this.headerService.updateName(form.value).subscribe(() => {
                this.showNameEditor = false;  
                this.submitted = false;         
            });
        }
    }
}
